namespace AgerLMS.WebSite {
    export interface LearningPageWidgetRequest {
        rightClickDisabled : boolean;
        watermarkDisabled: boolean;
        orderItemId? : number;
    }

    @Serenity.Decorators.registerClass()
    export class LearningPageWidget extends Serenity.Widget<LearningPageWidgetRequest> {

        contentElement: JQuery;
        _orderItemId: number;

        constructor(element: JQuery, opt: LearningPageWidgetRequest) {
            super(element, opt);

            this.contentElement = $("#learningPageContent");
            this._orderItemId = opt.orderItemId;

            if (opt.rightClickDisabled) {
                var neolcak = () => Q.log("hop dedik abii ne oluyor yanii!!!");
                document.addEventListener(
                    "contextmenu",
                    function (t) {
                        neolcak();
                        return t.preventDefault();
                    },
                    !1
                );
                //prevent ctrl + u and ctrl + shift + i and f12
                $(document).keydown(function (event) {
                    if (event.keyCode == 123) {
                        neolcak();
                        return false;
                    } else if (event.ctrlKey && event.shiftKey && event.keyCode == 73) {
                        neolcak();
                        return false;
                    } else if (event.ctrlKey && event.keyCode == 85) {
                        neolcak();
                        return false;
                    }
                });
            }

            var self = this;
            $("body").on("click", ".tab-item", function () {
                let e = $(this);
                if (!e.hasClass("active")) {
                    var n = e.attr("data-type"),
                        o = e.attr("data-id");
                    $(".tab-item-info").slideUp(),
                    $(".tab-item").removeClass("active"),
                    $(".certificate-item").removeClass("active"),
                    e.addClass("active"),
                    e.find(".tab-item-info").slideDown(),
                    $(window).width() < 992 && $(".learning-page-tabs").removeClass("show"),
                    "assignment" !== n && (self.loading(), self.a(o, n, self._orderItemId));
                }
            });
        }


        private a(n : any, a: any, oiId: any) {
            var self = this;
            var i = { type: a, id: n, orderItemId: oiId };
            $.post(Q.resolveUrl("~/egitim-goruntule/ogebilgisi"), i, function (n) {
                if ("session" === a) {
                } else
                    "file" === a
                        ? (function (n) {
                              if ((n.online_viewer && "0" !== n.online_viewer) || (n.downloadable && "0" !== n.downloadable)) {
                                  var a = "";
                                  if (n.online_viewer && "0" !== n.online_viewer)
                                      (a += '<div class="d-flex flex-column p-10 h-100">'),
                                          (a += '<iframe src="/ViewerJS/index.html#'
                                              .concat(n.file_path, '" class="file-online-viewer rounded-sm')
                                              .concat("", '" frameborder="0" allowfullscreen></iframe>'));
                                  else if (n.downloadable && "0" !== n.downloadable) {
                                  }
                                  self.contentElement.html(a);
                              } else
                                  switch (n.storage) {
                                      case "upload":
                                      case "youtube":
                                      case "vimeo":
                                      case "external_link":
                                      case "s3":
                                        if (n.can_try) {
                                          var w = $('<div class="learning-content-video-player w-100"></div>');
                                          
                                          self.contentElement.html(w as any); 
                                          (window as any).handleVideoByFileId(n.id, w, function () {});
                                        }
                                        else 
                                        {
                                            let s = self.o("Bu videoyu izleme hakkınız dolmuştur.", "", "quiz.svg", "");
                                            self.contentElement.html(s);
                                        }
                                        break;
                                  }
                              var g;
                          })(n.file)
                        : "quiz" === a &&
                          (function (t) {
                              var title = n.title,
                                  a = Q.text("WebSite.Text.goToTheQuizPageForMoreInformationLang"),
                                  i = "";
                              i = n.can_try
                                  ? '\n<a href="/lms/'.concat(n.id, '/quiz-start" target="_blank" class="btn btn-primary btn-sm mt-15">').concat(Q.text("WebSite.Text.quizPageLang"), "</a>\n            ")
                                  : '\n<button type="button" class="js-cant-start-quiz-toast btn btn-primary btn-sm mt-15 disabled">'.concat(Q.text("WebSite.Text.quizPageLang"), "</button>\n            ");
                              var s = self.o(title, a, "quiz.svg", i);
                              self.contentElement.html(s);
                          })(n.quiz);
                var s, r, l, c;
            });
        }

        private o(t, e, n, y = null) {
            var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
            return '<div class="d-flex align-items-center justify-content-center w-100 h-100">\n                    <div class="learning-content-box d-flex align-items-center justify-content-center flex-column p-15 p-lg-30 rounded-lg">\n                        <div class="learning-content-box-icon">\n                            <img src="/lms/assets/default/img/learning/'
                .concat(n, '" alt="downloadable icon">\n                        </div>\n\n                        <h4 class="font-16 font-weight-bold text-dark ')
                .concat(null != o ? o : "", '">')
                .concat(t, '</h4>\n\n                        <span class="font-14 font-weight-500 text-gray mt-5">')
                .concat(e, "</span>\n\n                        ")
                .concat(null != a ? a : "", "\n                    </div>\n                </div>");
        }
        private loading() {
            var t = '<div class="learning-content-loading d-flex align-items-center justify-content-center flex-column w-100 h-100">\n            <img src="/lms/assets/default/img/loading.gif" alt="">\n            <p class="mt-10">'.concat(
                Q.text("WebSite.Text.pleaseWaitForTheContentLang"),
                "</p>\n        </div>"
            );
            this.contentElement.html(t);
        }

        private yourrighttowatchhasexpired() {
            var t = '<div class="learning-content-loading d-flex align-items-center justify-content-center flex-column w-100 h-100">\n            <img src="/lms/assets/default/img/loading.gif" alt="">\n            <p class="mt-10">'.concat(
                "İzleme hakkınızın süresi dolmuştur.",
                "</p>\n        </div>"
            );
            this.contentElement.html(t);
        }
    }
}